import { forwardRef, useState } from "react";
import styles from "./Input.module.scss";
import { isEmpty } from "../util/validator";

const Input = forwardRef(function Input(props, ref) {
  const { label, id, error, mandatory, clearError, setError, ...otherProps } =
    props;

  function changeHandler(event) {
    if (mandatory === true)
      !isEmpty(event.target.value) ? clearError(id) : setError(id);
  }
  return (
    <div className={styles.formGroup}>
      <label>
        {label}
        {mandatory && <label className={styles.mandatory}>*</label>}
        <input {...otherProps} ref={ref} onChange={changeHandler}/>
      </label>
      <div className="error">{error && <p>{error}</p>}</div>
    </div>
  );
});

export default Input;
